import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Tag } from '@blueprint/ui';
import { CTALink } from 'listing-details/components/CTA/CTA';

export const VirtualTourContainer = styled('div')(css`
    width: 100%;
`);

export const SupportedTour = styled('div')(
    ({ theme }) => css`
        height: 100%;
        padding: ${theme.spacing['8px']};
        background-color: ${theme.colors['graphic-background-contrast']};
        iframe {
            border-radius: ${theme.borderRadius['300']};
            width: 100%;
            height: 100%;
        }
    `
);

export const UnsupportedTour = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        padding: ${spacing['spacing-2']};

        ${CTALink} {
            width: 100%;

            ${mq.large} {
                width: 40%;
            }
        }
    `
);

export const Error = styled('div')(() => {
    return css`
        margin: auto;
    `;
});

export const NavControls = styled('div')(({ theme }) => {
    return css`
        position: absolute;
        top: 0;
        left: 0;

        ${theme.mq.medium} {
            margin-top: ${theme.spacing['4px']};
        }
    `;
});

export const NavButton = styled('button')(({ theme }) => {
    return css`
        background: none;
        height: 3rem;
        padding: 0;
        border: none;
        margin-top: ${theme.spacing['2px']};
        margin-left: ${theme.spacing['8px']};

        ${theme.mq.medium} {
            margin-left: ${theme.spacing['16px']};
        }
    `;
});

export const ProgressIndicator = styled('div')(({ theme }) => {
    return css`
        position: absolute;
        top: ${theme.spacing['64px']};
        left: 50%;
        transform: translateX(-50%);
        pointer-events: none;

        ${Tag} {
            display: inline-flex;
            align-items: center;
            background-color: ${theme.colors['purple-dark-opacity80']};
            color: ${theme.colors.white};
            font-weight: ${theme.type.normal};
            font-size: 1rem;
            line-height: 1.375;
            padding: ${theme.spacing['4px']} ${theme.spacing['8px']}
                ${theme.spacing['4px']} ${theme.spacing['8px']};

            ${theme.mq.large} {
                font-size: 1.125rem;
                padding: ${theme.spacing['8px']};
            }

            svg {
                display: inline-block;
                margin-right: ${theme.spacing['4px']};
            }
        }
    `;
});
